import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import { PROMOTION_PERIOD_TYPE } from '@Root/contants/myhousePromotion'

export type ModalState = {
  isOpened: boolean
  type: MODAL_TYPE
  title: string | null
  myhouseNo: string | null
  complexNo: string | null
  phoneList: Array<string> | null
  promotionPeriod: PROMOTION_PERIOD_TYPE | null
  confirmFlag: boolean
  confirmModal: MODAL_TYPE
  cancelModal: MODAL_TYPE
  nclickConfirm: string | null
  nclickCancel: string | null
  address: string
}

export interface ModalUpdateTypeData {
  type: MODAL_TYPE
  title: string | null
  myhouseNo: number | string | null
  complexNo: number | string | null
  phoneList: Array<string> | null
  promotionPeriod: PROMOTION_PERIOD_TYPE | null
  nclickConfirm: string | null
  nclickCancel: string | null
  address: string
}

const initialState: ModalState = {
  isOpened: false,
  type: MODAL_TYPE.NONE,
  myhouseNo: null,
  title: null,
  phoneList: null,
  promotionPeriod: null,
  confirmFlag: false,
  confirmModal: MODAL_TYPE.NONE,
  cancelModal: MODAL_TYPE.NONE,
  nclickConfirm: null,
  nclickCancel: null,
  address: '',
} as ModalState

const modalSlice = createSlice({
  name: 'myhouseModal',
  initialState,
  reducers: {
    updateIsOpened: (state: ModalState, action: PayloadAction<boolean>) => {
      state.isOpened = action.payload

      if (action.payload) {
        state.confirmModal = MODAL_TYPE.NONE
        state.confirmFlag = false
        state.cancelModal = MODAL_TYPE.NONE
      }
    },
    updateType: (state: ModalState, action: PayloadAction<ModalUpdateTypeData>) => {
      const modalData = action.payload as ModalUpdateTypeData
      // state.type = modalData.type
      Object.assign(state, {
        ...state,
        type: modalData.type,
        myhouseNo: modalData.myhouseNo ?? null,
        complexNo: modalData.complexNo ?? null,
        title: modalData.title ?? null,
        phoneList: modalData.phoneList ?? null,
        promotionPeriod: modalData.promotionPeriod ?? null,
        nclickConfirm: modalData.nclickConfirm ?? null,
        nclickCancel: modalData.nclickCancel ?? null,
        address: modalData.address ?? '',
      })
    },
    updateConfirmFlag: (state: ModalState, action: PayloadAction<boolean>) => {
      state.confirmFlag = action.payload
    },
    updateConfirmModal: (state: ModalState, action: PayloadAction<MODAL_TYPE>) => {
      state.confirmModal = action.payload
    },
    updateCancelModal: (state: ModalState, action: PayloadAction<MODAL_TYPE>) => {
      state.cancelModal = action.payload
    },
  },
  extraReducers: {},
})

export const { updateIsOpened, updateType, updateConfirmFlag, updateConfirmModal, updateCancelModal } = modalSlice.actions
export default modalSlice.reducer
